var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWhiteCurve(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 290,
    viewBox: "0 0 1440 290",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M-0.00186431 80.7616C-0.00572653 80.5049 -0.00572591 80.251 -0.00186431 80V80.7616C0.327658 102.665 28.7764 145 86.4994 145H511.997C537.496 145 566.996 155.6 592.996 212C606.329 238 647.196 290 719.995 290H-0.00186431V80.7616Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1439.99 80.7616C1440 80.5049 1440 80.251 1439.99 80V80.7616C1439.66 102.665 1411.21 145 1353.49 145H927.994C902.494 145 872.994 155.6 846.994 212C833.661 238 792.795 290 719.995 290H1439.99V80.7616Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteCurve);
export default __webpack_public_path__ + "static/media/white_curve.4c06e5936992512381b5b3218076fd28.svg";
export { ForwardRef as ReactComponent };